<template>
  <div
    v-if="visible"
    class="float-window"
    :style="{
      left: `${left}px`,
      top: `${top}px`,
      width: `${width}px`,
      height: `${height}px`
    }"
    @mouseover="stop"
    @mouseleave="start" @click='gotoUrl(image)'
  >
    <div class="float-window-close" @click.stop="close">
      <img src="@/assets/images/ytHome/close-circle.png">
    </div>
     <div class='float-txt'>
       <p class='float-title'>{{image.title}}</p>
       {{image.subtitle}}
     </div>
  </div>
</template>

<script>
export default {
  name: 'FloatWindow',
  props: {
    image: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    speed: {
      type: Number,
      default: 1000 / 60
    }
  },
  data () {
    return {
      visible: false,
      top: 0,
      left: 0,
      maxX: 0,
      maxY: 0,
      directionX: -1,
      directionY: -1
    }
  },
  mounted () {
    this.setup()
    this.top = window.innerHeight - this.height
    this.left = window.innerWidth - this.width
    this.visible = true
    window.addEventListener('resize', this.setup)
    this.start()
  },
  destroyed () {
    this.close()
  },
  methods: {
    /**
     * 配置
     */
    setup () {
      this.maxX = window.innerWidth - this.width // X轴边界
      this.maxY = window.innerHeight - this.height // Y轴边界
    },
    /**
     * 开始移动
     */
    start () {
        this.timer = setInterval(this.move, this.speed)
      
      
    },
    /**
     * 停止移动
     */
    stop () {
      clearInterval(this.timer)
    },
    /**
     * 移动飘窗
     */
    move () {
      const rect = this.$el.getBoundingClientRect()
      if (rect.x >= this.maxX) {
        this.directionX = -1
      } else if (rect.x <= 0) {
        this.directionX = 1
      }
      if (rect.y >= this.maxY) {
        this.directionY = -1
      } else if (rect.y <= 0) {
        this.directionY = 1
      }
      this.left += this.directionX
      this.top += this.directionY
    },
    /**
     * 关闭飘窗
     */
    close () {
      this.visible = false
      window.removeEventListener('resize', this.setup)
      clearInterval(this.timer)
    },
    gotoUrl(item){
      if(item.url){
        window.open(item.url)
      }else{
         this.$router.push({
          path: "/yt/detail",
          query: {
            contentId: item.contentId, 
            tabName: '飘窗'
          },
        });
      }
    }
  }
}
</script>

<style lang='scss'>
.float-window{
  display: block;
  transform : translateZ(0);
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 99;
  cursor: pointer;
  background:url(../../assets/images/ytHome/pc.png) no-repeat center;
  .float-window-close{
    text-align: right;
    
  }
  .float-txt{
    padding:10px 20px 10px 27px;
    line-height: 22px;
    overflow:hidden;
      text-overflow: ellipsis;
      word-break:break-all;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2;
      height:90px;
    .float-title{
      font-size: 18px;
      text-align: center;
      font-weight: bold;
      line-height: 40px;
       overflow:hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
   
  }
}
</style>